import t from "../../translations";

const redQuotation = [
    t('red_quotation'), 
  ];
  
  export default redQuotation;
  